import gql from 'graphql-tag'

export default gql`mutation removeProjectInvoiceClient($project_id: String!, $client_id: Int!) {
    removeProjectInvoiceClient(project_id: $project_id, client_id: $client_id) @client
}`